var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"historyList mb30"},[_c('div',{staticClass:"logoTitle colorBlack"},[_c('p',{staticClass:"main"},[_c('strong',[_vm._v("경기장안내")])])]),_c('img',{attrs:{"src":require("@/assets/img/stadium.png"),"alt":""}})])])])
}]

export { render, staticRenderFns }